/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Jade_Snail_KnitInputs */

const en_gray_jade_snail_knit = /** @type {(inputs: Gray_Jade_Snail_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_gray_jade_snail_knit = /** @type {(inputs: Gray_Jade_Snail_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Gray_Jade_Snail_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_jade_snail_knit = /** @type {((inputs?: Gray_Jade_Snail_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Jade_Snail_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_jade_snail_knit(inputs)
	return de_gray_jade_snail_knit(inputs)
});